import { Component } from '@angular/core';
import { Transition } from '@uirouter/core';

import { PurchaseService } from '../../services/purchase.service';
import { PurchaseExitService } from '../../services/purchase-exit.service';
import { PurchaseStepsService } from '../../services/purchase-steps.service';
import { TaxExemptionService } from '../../services/tax-exemption.service';

@Component({
  selector: 'purchase',
  templateUrl: './purchase.component.html',
  styleUrls: ['./purchase.component.scss'],
  standalone: false,
})
export class PurchaseComponent {
  constructor(
    private transition: Transition,
    private purchaseExitService: PurchaseExitService,
    public purchaseService: PurchaseService,
    public purchaseStepsService: PurchaseStepsService,
    public taxExemptionService: TaxExemptionService,
  ) {
    this.purchaseService.init();
    this.purchaseStepsService.init();
    this.taxExemptionService.init(this.purchaseService.getEstimate);
  }

  redirect() {
    this.purchaseExitService.exit(this.transition);
  }

  close() {
    if (!this.purchaseService.purchase.reloadingCompany) {
      this.redirect();
    } else {
      this.purchaseService.loading = true;

      this.purchaseService.onCompanyReload(() => {
        this.purchaseService.loading = false;

        this.redirect();
      });
    }
  }
}
